import styled from "styled-components";

interface IStyles {
    isCurrentItemFromSameUser?: boolean;
    isBottomSectionEmpty?: boolean;
    isHost?: boolean;
}

const TOAST_BOTTOM_MARGIN_WITH_CHECKOUT_CTA = "100px";
const TOAST_BOTTOM_MARGIN_WITHOUT_CHECKOUT_CTA = "64px";

export const Container = styled.div(({ theme }) => {
    return {
        background: theme.colors[theme.colorMode].background_Primary,
        overflow: "hidden",
        borderRadius: theme.spacing.medium,
    };
});

export const ContainerWrapper = styled.div<IStyles>(({ theme, isCurrentItemFromSameUser }) => {
    return {
        marginTop: theme.spacing.small,
        background: isCurrentItemFromSameUser
            ? `linear-gradient(to top, ${theme.colors[theme.colorMode].background_Primary} 0%, ${
                  theme.colors[theme.colorMode].primary
              } 100%)`
            : theme.colors[theme.colorMode].background_Primary,
        padding: "1px",
        borderRadius: `calc(${theme.spacing.medium} + 1px)`,
    };
});

export const AddMoreItemsContainer = styled.div(({ theme }) => {
    return {
        padding: `0 ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`,
    };
});

export const MainContainer = styled.div`
    margin-top: ${(props) => props.theme.spacing.large};
`;

export const PageContainer = styled.div<IStyles>(({ theme, isHost }) => {
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: isHost ? "auto" : "100%",
        paddingBottom: isHost ? `calc(${theme.spacing.xLarge} * 4 + ${theme.spacing.medium} + var(--sab, 0px))` : 0,
    };
});

export const CartGroupOrderItemContainer = styled.div(({ theme }) => {
    return {
        margin: `0 ${theme.spacing.medium}`,
    };
});

export const TOAST_CONTAINER_CLASSNAME = "toast";

export const ToastContainer = styled.div<IStyles>(({ isBottomSectionEmpty, theme }) => ({
    [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
        bottom: isBottomSectionEmpty ? TOAST_BOTTOM_MARGIN_WITHOUT_CHECKOUT_CTA : TOAST_BOTTOM_MARGIN_WITH_CHECKOUT_CTA,
        left: theme.spacing.medium,
        right: theme.spacing.medium,
        marginLeft: "auto",
        marginRight: "auto",
        width: "fit-content",
        maxWidth: `calc(100% - 2 * ${theme.spacing.medium})`,
        zIndex: 9,
    },
}));
